import { createResolvable } from "utils"

export type ApiConfig = {
  apiBaseUrl: string
  apiToken: string
}

export const { promise, resolve } = createResolvable<ApiConfig>()

export const initializeBackofficeApi = (config: ApiConfig) => {
  resolve(config)
}

export const getConfig = () => {
  return promise
}
